import { queryPost } from '@/api/apiConfig';

export default {
  getToken () {
    const formData = new FormData();
    formData.append('client_id', process.env.VUE_APP_CLIENT_ID);
    formData.append('grant_type', 'password');
    formData.append('scope', process.env.VUE_APP_AUTH_SCOPE);
    formData.append('username', process.env.VUE_APP_AUTH_USERNAME);
    formData.append('password', process.env.VUE_APP_AUTH_PASSWORD);

    return queryPost('/connect/token', formData);
  }
};
